const projectConfig = {
  version: '1.5.2',  // Mobile app version number only (web app version number is set in social-stack-web/package.json)
  name: 'FitPros',    // Display name               Should also match APP_DISPLAY_NAME in in xcode (target>Build settings>User-Defined)
  slug: 'FitPros',    // generates app.json value   Should also match APP_MODULE_NAME in in xcode (target>Build settings>User-Defined), and APP_COMPONENT_NAME in app/build.gradle
  metaDescription: "FitPros is a workplace wellbeing benefits provider, empowering employers to put their employees' mental, physical, social and financial health first. Workplace wellbeing is a culture. We want to inspire and uncover the highest potential in people, at work, every day, so they can show up healthy, and at their best. Our offerings include health talks, fitness classes, team building activities, and social connection events that help employees stay connected to each other, and with their employer.",
  primaryColorOne: '#A30664',
  primaryColorTwo: '#A30664',
  secondaryColorOne: '#7E1C62',
  secondaryColorTwo: '#D4145A', // includes error text
  secondaryColorThree: '#7E1C62',
  defaultCoverPhotoColor: '#7E1C62',
  primaryFontBaseSize: 13, // Base body copy size. Other sizes are relative. Tweak on a per-font basis. 12p is default (the base value throughout before implementing relative font sizes)
  secondaryFontBaseSize: 20, // Base header/tite size. Other sizes are relative. Tweak on a per-font basis. 20p is default (the base value throughout before implementing relative font sizes)
  fontLeading: 1.5, // a multiplier for line-height. 1.25 is default
  useEmphasisFonts: false, // use emphasis/italic fonts for headers, event titles, and profile names.
  primaryCountryCode: 'US',
  addressFAQ: true, // displays questions and answers about why address is required.
  allowsOtherCountries: true, // if false, restricts location search results to primaryCountryCode. If true, enables international address features in profile/creation. 
  internationalSupport: true,
  privacyPolicy: 'https://www.fitpros.com/app-privacy-policy',
  termsConditions: 'https://www.fitpros.com/terms-and-conditions',
  cookiePolicy: 'https://www.fitpros.com/app-privacy-policy',
  communityGuidelines: 'https://www.fitpros.com/code-of-conduct',
  userSupportLink: 'https://fitpros.com/support', // If provided, shows a "Help Center" link in the user's settings (mobile) or sidebar (web)
  purchaseableShirt: false, // unused, but views and code exist to add it. according to niki on 02/16/2024, BU has no shirt.
  shirtPreviewTitle: null,
  shirtPreviewTagline: null,
  shirtPreviewMessage: null,
  shirtPreviewMessageNote: null,
  getShirtText: null,
  purchaseTitle: null,
  purchaseConfirmationTitle: null, // determine if other projects will have the confirmation match the preview tagline
  purchaseContactEmail: null,
  alertTitle: 'FitPros',
  supportEmail: 'techsupport@fitpros.com',
  storeKey: 'FitPros',
  prodHost: 'live.fitpros.com',
  prodURL: 'https://live.fitpros.com/',
  stagingURL: 'https://live-stage.fitpros.com/',
  devURL: 'https://fitpros-api-dev.fly.dev/',
  devAPIURL: 'https://fitpros-api-dev.fly.dev/',
  stageAPIURL: 'https://fitpros-api-dev.fly.dev/',
  prodAPIURL: 'https://fitpros-api-prod.fly.dev/',
  apiVersion: 'api/',
  registrationEmailWarning: '',
  verificationAccountTitle: 'Verification Code',
  emailConfirmationText:
    'For your security, enter the confirmation code that was sent to the email you provided.',
  emailNotReceivedText: "Didn't receive the email?\nCheck your spam folder or ",
  verificationType: 'code', // code or emailLink
  verificationCodeLength: 6,
  // The Profile creation flow that's entered AFTER email/workspace verification.
  // `screen` values. Used by React Native. See App.js for the stackNavigator names.
  // `path` values. For React Web. See Registration.js. These path values correspond to URLs like https://yourvariant.com/registration/personal_info. See Registration.js.
  registerProfileSteps: [
    { screen: 'SocialProfile', path: 'social_info' },
    { screen: 'MilitaryService', path: 'extra_info' }, // experiment with changing this path "military_info" is user facing.
    { screen: 'PrivacyWaiver', path: 'privacy_info' },
  ],
  profileLocationStateOptions: [ // specified state options for manual entry for account address on registration and updating profile information
  ],
  phoneRequested: false, // if true, a field for phone number is included on profile create/edit views.
  phoneRequired: false, // if true, the phone number is required.
  serviceCheckTitle: '',
  serviceCheckBody: '',
  emailAddressMessage: 'Enter your email address.',
  FirstNameLabel: 'FIRST NAME',
  LastNameLabel: 'LAST NAME',
  allowBlankLastName: false,
  ProfileBoxFiller: 'Enter Profile Description: Company, Position, Etc.',
  profileInfoTitle: 'My Role',
  leaderRoleDisplay: null,
  distanceUnits: 'mi',
  facebookID: '414454007478608',
  simplifyGroupTypeNames: false, // display simple the group types instead of using backend datatypes like "National Group" and "Chapter". See shimGroupTypeName(kind) in Helpers.js
  limitedEmail: null,
  melissaVerify: false,
  defaultEventImages: true,
  localEventTabName: 'On-Site Events',
  hasPast90Lozenge: true, // if true, a "Past 90 days" lozenge is shown on the events tab.
  orgName: 'FitPros',
  appleId: '6470065354',
  androidId: 'com.fitpros.FitPros', //applicationId set in app/build.gradle per project flavor
  hasGroups: false, // If true, groups tab is shown on the main tabs. Doesn't affect backend models/api. This also impacts if the group filtering option is present for event filtering.
  hasAnchorChapter: false, // If true, the app automatically assigns an anchor group/chapter. Note: this might happen regardless of this setting on the backend.
  showProfileChapter: false, // if true, the preferred chapter is displayed with users in lists, etc.
  GCMSenderId: '194168857953', // 7953 FitPros, must match google-services.json project_number. Managed in Firebase console (fitpros-workplace-wellbeing). Login with google workspace account. Dan Walton, Depash N, and John-Paul are Owners.
  hasChallenges: true, // if true, client app will show challenge tab, related views, includeing badges on profiles. Requires backend to support Challenges functionality.
  hasPayment: false, // if true, complex. alters the behavior of the create event button, showing donation tiers, and whether purchases should be loaded on myprofile. Should be named dba-style-donation-tiers or something. Possibly collides with other settings like alwaysShowEventButton.
  genderRequested: false, // if true, a gender selection appears on profile/registration. Not necessarily public.
  validGenderOptions:[],
  supportsAnonymousUsers: false,
  hasProfileInfo: false,
  eventRsvpLabel: "RSVP",
  eventRsvpHasRegistration: false, // if true, events can include a registration URL and RSVP will launch it if added (DBA feature)
  membershipDiscount: false,
  eventAttendeeListDownload: false,
  hasShareSupport: false,
  hasOpenGraphPreviews: true, // website previews in posts. Incur cost with opengraph.io. If set to true, a key is required in APIKeys.js
  hasEventHostSelection: false, // when true, an even host other than the creator can be selected when creating a group event.
  hasWorkspaces: true, // if true, users are added to a workspace based on their email domain. The app client is mostly agnostic to this.
  hasInAppAnalytics: true, // if true, event_leaders, staff, and superusers can view in-app analytics.
  inAppAnalyticsLabel: 'FITPROS LIVE ANALYTICS',

  // event creation rules
  leaderRole: 'event_leader',               // Usually, the backend only has one permissions group: "event_leader". DBA-style donation levels added purchase_tier_perms.
  alwaysShowEventButton: false,             // Ignore ALL other checks and always show the create-event button. Will be buggy unless you really know what you're doing.
  limitedNonGroupEventCreation: true,       // event creation limited to users with a specific role
  allowsVirtualEventsOutsideGroups: true,  // if false, the create event button will only be shown on the local/onsite events tab (if allowsLocalEventsOutsideGroups is true), and the create event view will not display tabs allowing you to toggle between local and virtual events.
  allowsLocalEventsOutsideGroups: true,    // if false, the create event button will only be shown on the events tab (if allowsVirtualEventsOutsideGroups is true), and the create event view will not display tabs allowing you to toggle between local and virtual events. Additionally, this partially determines if there is is "all events", "group events", and "member events" filter tabs for local event filters
  eventsHaveAttendeeLimit: false,
  sessionEndedMessage:'This session has ended',
  hasOktaAuthentication: true,  // if true, Sign in with Okta will be displayed on the login screen. Requires admin database records.
  hideRemovedEventPosts: false, // if an event has been removed, determine if the posts related to that removed event should be hidden on the feed. See `filterRemovedEvents` in FeedHelpers.js for more info.

  hasEverythingFeed: false, // if true, the feed includes all posts. Requires a backend setting. See https://phabricator.retronyms.com/D8759
  canViewLikeList: false, // if true, users can view who liked a post. Requires backend endpoint: /user/<id>/reactions/<uuid>/list.
};

export {projectConfig};
